/* Pond Provisions Co – header (7-10-2026): search as you type, "My pond", mega menus, slim header after scrolling, phone menu.
   Only reads the shop (predictive search, collection counts); never changes a product or price. */
(function () {
  'use strict';
  var H = document.getElementById('ph');
  if (!H) return;
  var ROOT = H.dataset.root || '/', SURL = H.dataset.search || '/search', CU = H.dataset.cu || '/collections';
  var $ = function (id) { return document.getElementById(id); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var fmt = function (n) { return Math.round(n).toLocaleString('en-GB'); };
  var m1 = function (n) { return String(Math.round(n * 10) / 10); };
  var desk = window.matchMedia('(min-width: 990px)');
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var WRAP = $('ph-wrap'), SCRIM = $('ph-scrim'), DRAWER = $('ph-drawer');

  /* ---------- my pond (shared with planner, product pages and basket) ---------- */
  var P = { L: 4, W: 3, D: 0.9, stock: 'gold', sun: false, has: false };
  function load() {
    try {
      var o = JSON.parse(localStorage.getItem('ppc-pond') || 'null');
      if (o && +o.L > 0 && +o.W > 0 && +o.D > 0) { P.L = +o.L; P.W = +o.W; P.D = +o.D; P.stock = o.stock || 'gold'; P.sun = o.sun === true || o.sun === 'full'; P.has = true; }
    } catch (e) {}
  }
  function save() {
    try {
      var o = JSON.parse(localStorage.getItem('ppc-pond') || '{}') || {};
      o.L = P.L; o.W = P.W; o.D = P.D; o.stock = P.stock;
      localStorage.setItem('ppc-pond', JSON.stringify(o));
    } catch (e) {}
    P.has = true;
    try { document.dispatchEvent(new CustomEvent('ppc:pond', { detail: { L: P.L, W: P.W, D: P.D, stock: P.stock, from: 'header' } })); } catch (e) {}
  }
  var LADDER = [3000, 4500, 6000, 9000, 12000, 15000, 20000, 30000, 45000];
  function calc(p) {
    p = p || P;
    var V = Math.round(p.L * p.W * p.D * 1000 / 10) * 10;
    var f = { wild: 1, gold: 2, koi: 3 }[p.stock] || 2;
    var need = Math.round(V * f * (1 + (p.D < 0.75 ? 0.25 : 0) + (p.sun ? 0.25 : 0)) / 100) * 100;
    var a = Math.max(p.L, p.W), b = Math.min(p.L, p.W);
    var set = LADDER.filter(function (x) { return x >= need; })[0] || null;
    return { V: V, need: need, nL: a + 2 * p.D + 0.6, nW: b + 2 * p.D + 0.6, set: set, word: { wild: 'wildlife and plants', gold: 'goldfish', koi: 'koi' }[p.stock] || 'goldfish' };
  }
  var link = function (h, q) { return CU + '/' + h + (q ? '?' + q : ''); };
  function panel(kind) {
    var c = calc(), has = P.has;
    var chg = has ? '<button type="button" class="ph-pp__x" data-ph="pond">Change my pond</button>' : '';
    var addB = '<button type="button" class="ph-btn ph-btn--dark" data-ph="pond">Add my pond</button>';
    var x = function (e, t, b, cta, extra) { return '<span class="ph-pp__e">' + e + '</span><p class="ph-pp__t">' + t + '</p><p class="ph-pp__b">' + b + '</p>' + (extra || '') + (cta || '') + chg; };
    var btn = function (t, href) { return '<a class="ph-btn ph-btn--dark" href="' + esc(href) + '">' + esc(t) + '</a>'; };
    var chips = function (arr) { return '<div class="ph-chips">' + arr.map(function (a) { return '<a href="' + esc(a[1]) + '">' + esc(a[0]) + '</a>'; }).join('') + '</div>'; };
    if (kind === 'liner') {
      if (!has) return x('Sized for my pond', 'Find the liner size for your pond', 'Add your pond’s length, width and deepest point and we work out the sheet you need.', addB);
      return x('Sized for my pond', 'Your pond needs a sheet of at least ' + m1(c.nL) + ' m × ' + m1(c.nW) + ' m', 'That is ' + m1(Math.max(P.L, P.W)) + ' × ' + m1(Math.min(P.L, P.W)) + ' m plus twice the ' + m1(P.D) + ' m depth, and 30 cm on every edge to tuck under the edging.', btn('See flexible liners', link('pond-liners', 'g=Flexible%20%26%20PVC%20liners&types=Pond%20Liners')), '<p class="ph-pp__b">Sheet liner pages open at this size.</p>');
    }
    if (kind === 'filter') {
      if (!has) return x('Sized for my pond', 'Which filter is big enough?', 'Filters are rated for ponds with few or no fish. Add your pond and we work out the rating you need.', addB);
      return x('Sized for my pond', 'Your ' + fmt(c.V) + ' litre pond with ' + c.word + ' needs a filter rated for ' + fmt(c.need) + ' litres', 'Filters are rated for ponds with few or no fish, so we double the litres for goldfish and treble them for koi' + (P.D < 0.75 ? ', and add a quarter for a pond under 75 cm deep.' : '.'), btn('Filters rated ' + fmt(c.need) + ' L and up', link('pond-filters', 'rated=' + c.need)));
    }
    if (kind === 'set') {
      if (!has) return x('Sized for my pond', 'Which set is big enough?', 'Each set is rated by pond size. Add your pond and we pick the smallest set that covers it.', addB);
      return x('Sized for my pond', 'Your pond needs a set rated for ' + fmt(c.need) + ' litres', c.set ? 'The smallest of our boxed sets that covers it is the ' + fmt(c.set) + ' litre set. Every set pairs the pump with its filter.' : 'That is more than our largest boxed set (45,000 litres). Call us or ask for a quote and we will put a system together.', c.set ? btn('Sets rated ' + fmt(c.need) + ' L and up', link('pump-and-filter-sets', 'rated=' + c.need)) : btn('Request a quote', ROOT + '#quote'));
    }
    if (kind === 'pump') {
      if (!has) return x('Feeding a filter?', 'A pump & filter set pairs the right pump for you', 'Add your pond and we show the sets that are big enough.', addB);
      return x('Feeding a filter?', 'A pump & filter set pairs the right pump for you', 'For your ' + fmt(c.V) + ' litre pond with ' + c.word + (c.set ? ', the sets that fit start at ' + fmt(c.set) + ' litres.' : ', you need more than our largest boxed set.'), btn('Sets for my pond', link('pump-and-filter-sets', 'rated=' + c.need)));
    }
    if (kind === 'bulbs') {
      var W = [5, 7, 9, 11, 13, 18, 24, 36, 55];
      chg = '';
      return x('Find a bulb by wattage', 'The wattage is printed on the old bulb or on the UV unit', 'Then match the ends (single or double) and the length.', '', chips(W.map(function (w) { return [w + ' W', SURL + '?q=' + encodeURIComponent(w + 'w uvc bulb') + '&type=product&options%5Bprefix%5D=last']; })));
    }
    if (kind === 'water') {
      var PR = [['Green water', 'green'], ['Blanketweed', 'blanket'], ['Sludge', 'sludge'], ['Cloudy water', 'cloudy'], ['Losing water', 'leak'], ['New pond', 'new']];
      return x('What is wrong with the water?', 'Pick the problem and we show what treats it', has ? 'Bottle sizes are matched to your ' + fmt(c.V) + ' litre pond.' : 'Bottle sizes are matched to your pond’s litres.', '', chips(PR.map(function (p) { return [p[0], ROOT + '?prob=' + p[1] + '#problems']; })));
    }
    chg = '';
    return x('Starting a pond?', 'The pond planner sizes everything at once', 'Liner, underlay, pump and filter and a cover net, worked out from one set of measurements.', btn('Open the planner', ROOT + '#planner'));
  }
  function tip(kind) {
    if (!P.has) return '';
    var c = calc();
    if (kind === 'liner') return ['Your pond needs a sheet of at least ' + m1(c.nL) + ' × ' + m1(c.nW) + ' m.', 'Flexible liners →', link('pond-liners', 'g=Flexible%20%26%20PVC%20liners&types=Pond%20Liners')];
    if (kind === 'filter') return ['Your pond needs a filter rated for ' + fmt(c.need) + ' L.', 'Filters that fit →', link('pond-filters', 'rated=' + c.need)];
    if (kind === 'set' || kind === 'pump') return ['Your pond needs a set rated for ' + fmt(c.need) + ' L.', 'Sets that fit →', link('pump-and-filter-sets', 'rated=' + c.need)];
    if (kind === 'water') return ['Bottle sizes for ' + fmt(c.V) + ' L.', 'Water problem solver →', ROOT + '#problems'];
    return '';
  }
  function renderPond() {
    var c = calc();
    var chip = $('ph-chip'), v = $('ph-chip-v');
    if (v) v.textContent = P.has ? m1(P.L) + ' × ' + m1(P.W) + ' m · ' + fmt(c.V) + ' L' : 'Add its size';
    if (chip) chip.classList.toggle('is-empty', !P.has);
    var mv = $('ph-mp-v');
    if (mv) mv.innerHTML = P.has ? '<b>My pond</b> · ' + esc(m1(P.L) + ' × ' + m1(P.W) + ' m · ' + fmt(c.V) + ' L · ' + { wild: 'wildlife', gold: 'goldfish', koi: 'koi' }[P.stock]) : '<b>My pond</b> · add its size to see what fits';
    var mb = $('ph-mpb'); if (mb) mb.querySelector('em').textContent = P.has ? 'Change' : 'Add';
    H.querySelectorAll('[data-pp]').forEach(function (el) { el.innerHTML = panel(el.dataset.pp); });
    if (DRAWER) DRAWER.querySelectorAll('[data-tip]').forEach(function (a) {
      var t = tip(a.dataset.tip);
      if (!t) { a.hidden = true; return; }
      a.hidden = false; a.href = t[2]; a.innerHTML = '<b>' + esc(t[0]) + '</b> ' + esc(t[1]);
    });
  }
  /* popover working copy */
  var W = null;
  function popStats() {
    var c = calc(W);
    $('ph-sv').textContent = fmt(c.V) + ' L';
    $('ph-sl').textContent = m1(c.nL) + ' × ' + m1(c.nW) + ' m';
    $('ph-sr').textContent = fmt(c.need) + ' L+';
    H.querySelectorAll('[data-stock]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.stock === W.stock)); });
  }
  var POP = $('ph-pop'), CHIP = $('ph-chip'), MPB = $('ph-mpb');
  function openPop(focus) {
    closeAll();
    W = { L: P.L, W: P.W, D: P.D, stock: P.stock, sun: P.sun };
    ['L', 'W', 'D'].forEach(function (k) { $('ph-' + k).value = P.has ? m1(W[k]) : ''; $('ph-' + k).placeholder = m1(W[k]); });
    popStats();
    POP.hidden = false;
    if (desk.matches && CHIP) {
      var mr = POP.offsetParent ? POP.offsetParent.getBoundingClientRect() : { left: 0, width: window.innerWidth };
      var cr = CHIP.getBoundingClientRect();
      var left = Math.min(cr.left - mr.left, mr.width - POP.offsetWidth - 16);
      POP.style.left = Math.max(16, left) + 'px'; POP.style.right = 'auto';
    } else { POP.style.left = ''; POP.style.right = ''; }
    [CHIP, MPB].forEach(function (b) { if (b) b.setAttribute('aria-expanded', 'true'); });
    showScrim(true);
    if (focus !== false) setTimeout(function () { var i = $('ph-L'); if (i) i.focus(); }, 30);
  }
  function closePop() {
    if (!POP || POP.hidden) return;
    POP.hidden = true;
    [CHIP, MPB].forEach(function (b) { if (b) b.setAttribute('aria-expanded', 'false'); });
  }
  function savePop() {
    ['L', 'W', 'D'].forEach(function (k) { var v = parseFloat(String($('ph-' + k).value).replace(',', '.')); if (isFinite(v) && v > 0) W[k] = Math.min(k === 'D' ? 5 : 60, v); });
    P.L = W.L; P.W = W.W; P.D = W.D; P.stock = W.stock;
    save(); renderPond(); closeAll();
    if (CHIP && desk.matches) CHIP.focus();
  }
  if (POP) {
    POP.addEventListener('input', function (e) {
      var k = e.target.dataset && e.target.dataset.k; if (!k) return;
      var v = parseFloat(String(e.target.value).replace(',', '.'));
      if (isFinite(v) && v > 0) { W[k] = Math.min(k === 'D' ? 5 : 60, v); popStats(); }
    });
    POP.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.tagName === 'INPUT') { e.preventDefault(); savePop(); } });
  }

  /* ---------- scrim / closing ---------- */
  function showScrim(on) { if (SCRIM) SCRIM.hidden = !on; }
  var openK = null, hoverT = null, leaveT = null;
  function closeMega() {
    if (!openK) return;
    var b = H.querySelector('[data-mm="' + openK + '"]'), p = $('ph-mm-' + openK);
    if (b) b.setAttribute('aria-expanded', 'false'); if (p) p.hidden = true; openK = null;
  }
  function closeAll(keepScrim) {
    closeMega(); closePop(); closeRes(); closeDrawer();
    if (!keepScrim) showScrim(false);
  }
  if (SCRIM) SCRIM.addEventListener('click', function () { closeAll(); });

  /* ---------- mega menus ---------- */
  function openMega(k) {
    if (openK === k) return;
    closePop(); closeRes(); closeMega();
    var b = H.querySelector('[data-mm="' + k + '"]'), p = $('ph-mm-' + k);
    if (!b || !p) return;
    b.setAttribute('aria-expanded', 'true'); p.hidden = false; openK = k; showScrim(true);
  }
  var NAV = $('ph-nav');
  if (NAV) {
    NAV.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mm]'); if (!b) return;
      var k = b.dataset.mm;
      if (openK === k && !b._hovered) { closeMega(); showScrim(false); } else openMega(k);
      b._hovered = false;
    });
    NAV.addEventListener('mouseover', function (e) {
      if (!canHover.matches) return;
      clearTimeout(leaveT);
      var b = e.target.closest('[data-mm]'); if (!b) return;
      clearTimeout(hoverT);
      hoverT = setTimeout(function () { if (openK !== b.dataset.mm) { b._hovered = true; setTimeout(function () { b._hovered = false; }, 400); openMega(b.dataset.mm); } }, openK ? 60 : 160);
    });
    NAV.addEventListener('mouseleave', function () {
      if (!canHover.matches) return;
      clearTimeout(hoverT);
      leaveT = setTimeout(function () { if (openK) { closeMega(); showScrim(false); } }, 260);
    });
    NAV.addEventListener('mouseenter', function () { clearTimeout(leaveT); });
    NAV.addEventListener('keydown', function (e) {
      var b = e.target.closest('[data-mm]');
      if (b && e.key === 'ArrowDown') { e.preventDefault(); openMega(b.dataset.mm); var f = $('ph-mm-' + b.dataset.mm).querySelector('a,button'); if (f) f.focus(); }
    });
  }

  /* ---------- search as you type (Shopify predictive search) ---------- */
  var Q = $('ph-q'), RES = $('ph-res'), FORM = $('ph-form'), qT = null, qN = 0, lastQ = null;
  var money = function (v) { var n = parseFloat(v); if (!isFinite(n)) return ''; if (String(v).indexOf('.') < 0 && n >= 1000) n = n / 100; return '£' + n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); };
  var allUrl = function (q) { return SURL + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; };
  var SV = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.8-3.8"/></svg>';
  function closeRes() { if (!RES || RES.hidden) return; RES.hidden = true; if (Q) Q.setAttribute('aria-expanded', 'false'); }
  function openRes() {
    if (!RES) return;
    closeMega(); closePop(); closeDrawer();
    setB();
    RES.hidden = false; Q.setAttribute('aria-expanded', 'true'); showScrim(desk.matches);
  }
  function renderRes(q, r) {
    var prods = (r.products || []).slice(0, 6), cols = (r.collections || []).slice(0, 4), qs = (r.queries || []).slice(0, 4);
    var a = '<div class="ph-res__a">';
    if (qs.length) a += '<div class="ph-res__s ph-res__qs"><span class="ph-res__k">Searches</span>' + qs.map(function (x) { return '<a class="ph-res__q" role="option" href="' + esc(x.url || allUrl(x.text)) + '">' + SV + '<span>' + (x.styled_text ? x.styled_text.replace(/<(?!\/?mark>)[^>]*>/g, '') : esc(x.text)) + '</span></a>'; }).join('') + '</div>';
    if (cols.length) a += '<div class="ph-res__s"><span class="ph-res__k">Departments</span>' + cols.map(function (x) { return '<a class="ph-res__c" role="option" href="' + esc(x.url) + '"><span>' + esc(x.title) + '</span></a>'; }).join('') + '</div>';
    a += '<p class="ph-res__tip"><b>Looking for a part?</b> Type the wattage, the size or the model number printed on your filter or pump.</p></div>';
    var b = '<div class="ph-res__b"><span class="ph-res__k">Products</span>';
    if (prods.length) b += prods.map(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
      if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=140';
      var price = money(p.price), was = p.compare_at_price_max && parseFloat(p.compare_at_price_max) > parseFloat(p.price) ? money(p.compare_at_price_max) : '';
      return '<a class="ph-res__p" role="option" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64">' : '<i></i>') +
        '<span><b>' + esc(p.title) + '</b>' + (p.type ? '<small>' + esc(p.type) + '</small>' : '') + '</span><em>' + (was ? '<s>' + was + '</s>' : '') + esc(price) + '</em></a>';
    }).join('');
    else b += '<p class="ph-res__none">No products match “' + esc(q) + '” yet. Try fewer words, or the number on the part.</p>';
    b += '<a class="ph-res__all" href="' + esc(allUrl(q)) + '">See all results for “' + esc(q) + '” <span aria-hidden="true">→</span></a></div>';
    RES.innerHTML = a + b;
    RES.classList.remove('is-loading');
  }
  function suggest() {
    var q = Q.value.trim();
    if (!q) { closeRes(); lastQ = null; if (!desk.matches) showScrim(false); return; }
    if (q === lastQ && !RES.hidden) return;
    var n = ++qN;
    RES.classList.add('is-loading');
    var u = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources%5Btype%5D=product,collection,query&resources%5Blimit%5D=6&resources%5Blimit_scope%5D=each&resources%5Boptions%5D%5Bunavailable_products%5D=last&resources%5Boptions%5D%5Bfields%5D=title,product_type,variants.title,variants.sku,tag';
    fetch(u, { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (j) { if (n !== qN) return; lastQ = q; renderRes(q, (j.resources && j.resources.results) || {}); if (document.activeElement === Q || !RES.hidden) openRes(); })
      .catch(function () { if (n !== qN) return; RES.classList.remove('is-loading'); });
  }
  if (Q && RES) {
    Q.addEventListener('input', function () { clearTimeout(qT); qT = setTimeout(suggest, 160); });
    Q.addEventListener('focus', function () { if (Q.value.trim() && lastQ === Q.value.trim() && RES.innerHTML) openRes(); else if (Q.value.trim()) suggest(); });
    Q.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeRes(); showScrim(false); return; }
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && !RES.hidden) {
        var items = [].slice.call(RES.querySelectorAll('[role="option"], .ph-res__all'));
        if (!items.length) return;
        e.preventDefault();
        var i = items.indexOf(RES.querySelector('[aria-selected="true"]'));
        items.forEach(function (x) { x.removeAttribute('aria-selected'); });
        i = e.key === 'ArrowDown' ? (i + 1) % items.length : (i <= 0 ? items.length - 1 : i - 1);
        items[i].setAttribute('aria-selected', 'true'); items[i].scrollIntoView({ block: 'nearest' });
      }
      if (e.key === 'Enter' && !RES.hidden) { var s = RES.querySelector('[aria-selected="true"]'); if (s) { e.preventDefault(); location.href = s.href; } }
    });
    FORM.addEventListener('submit', function (e) { if (!Q.value.trim()) { e.preventDefault(); Q.focus(); } });
    /* shorter placeholder on phones */
    var phD = Q.placeholder, phM = Q.dataset.phM;
    var setPh = function () { Q.placeholder = desk.matches ? phD : phM || phD; };
    setPh(); if (desk.addEventListener) desk.addEventListener('change', setPh);
  }

  /* ---------- phone drawer ---------- */
  var BURGER = $('ph-burger');
  function setB() { var r = H.getBoundingClientRect(); var b = Math.max(0, Math.round(r.bottom)); document.documentElement.style.setProperty('--ph-b', b + 'px'); if (DRAWER) DRAWER.style.setProperty('--ph-b', b + 'px'); }
  function buildDrawer() {
    var box = $('ph-dr-list'); if (!box || box.childElementCount) return;
    var html = '';
    H.querySelectorAll('.ph-nb').forEach(function (b) {
      var k = b.dataset.mm, p = $('ph-mm-' + k); if (!p) return;
      var all = p.querySelector('.ph-mm__h a'), pp = p.querySelector('[data-pp]'), label = b.textContent.trim();
      var m = all && /All\s+([\d,]+)/.exec(all.textContent);
      var items = m ? '<a class="ph-dr__all" href="' + esc(all.getAttribute('href')) + '">All ' + esc(label.toLowerCase()) + '</a>' : '';
      p.querySelectorAll('.ph-mm__l a').forEach(function (a) { var sp = a.querySelectorAll('span'); items += '<a href="' + esc(a.getAttribute('href')) + '"><span>' + esc(sp[0].textContent) + '</span>' + (sp[1] ? '<small>' + esc(sp[1].textContent) + '</small>' : '') + '</a>'; });
      var kind = pp ? pp.dataset.pp : '';
      if (['liner', 'filter', 'set', 'pump', 'water'].indexOf(kind) > -1) items += '<a class="ph-dr__tip" data-tip="' + kind + '" href="#" hidden></a>';
      html += '<div class="ph-dr__d"><button type="button" class="ph-dr__b" aria-expanded="false" aria-controls="ph-dr-' + k + '"><span>' + esc(label) + '</span><span class="ph-dr__c">' + (m ? '<small>' + m[1] + '</small>' : '') + '<i class="ph-cv" aria-hidden="true"></i></span></button><div class="ph-dr__p" id="ph-dr-' + k + '" hidden>' + items + '</div></div>';
    });
    box.innerHTML = html;
    renderPond();
  }
  function openDrawer() {
    closeMega(); closePop(); closeRes();
    if (!DRAWER) return;
    buildDrawer(); setB(); DRAWER.hidden = false; BURGER.setAttribute('aria-expanded', 'true'); BURGER.setAttribute('aria-label', 'Close menu');
    document.documentElement.classList.add('ph-lock');
  }
  function closeDrawer() {
    if (!DRAWER || DRAWER.hidden) return;
    DRAWER.hidden = true; BURGER.setAttribute('aria-expanded', 'false'); BURGER.setAttribute('aria-label', 'Menu');
    document.documentElement.classList.remove('ph-lock');
  }
  if (BURGER) BURGER.addEventListener('click', function () { if (DRAWER.hidden) openDrawer(); else closeDrawer(); });
  if (DRAWER) DRAWER.addEventListener('click', function (e) {
    var b = e.target.closest('.ph-dr__b');
    if (b) {
      var on = b.getAttribute('aria-expanded') === 'true';
      DRAWER.querySelectorAll('.ph-dr__b[aria-expanded="true"]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); $(x.getAttribute('aria-controls')).hidden = true; });
      if (!on) { b.setAttribute('aria-expanded', 'true'); $(b.getAttribute('aria-controls')).hidden = false; }
      return;
    }
    var a = e.target.closest('a'); if (a && a.getAttribute('href').indexOf('#') > -1) closeDrawer();
  });

  /* ---------- clicks inside the header ---------- */
  H.addEventListener('click', function (e) {
    var t = e.target.closest('[data-ph], [data-stock], #ph-chip, #ph-mpb, #ph-depts');
    if (!t) return;
    if (t.id === 'ph-chip' || t.id === 'ph-mpb') { if (POP.hidden) openPop(desk.matches); else { closePop(); showScrim(false); } return; }
    if (t.id === 'ph-depts') { var on = !H.classList.contains('is-navopen'); H.classList.toggle('is-navopen', on); t.setAttribute('aria-expanded', String(on)); if (!on) { closeMega(); showScrim(false); } return; }
    if (t.dataset.stock) { W.stock = t.dataset.stock; popStats(); return; }
    var a = t.dataset.ph;
    if (a === 'close') { closeAll(); }
    else if (a === 'save') savePop();
    else if (a === 'pond') openPop();
    else if (a === 'focus') { e.preventDefault(); closeAll(); if (Q) { Q.focus(); Q.scrollIntoView({ block: 'nearest' }); } }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var wasMega = openK; closeAll();
    if (wasMega) { var b = H.querySelector('[data-mm="' + wasMega + '"]'); if (b) b.focus(); }
  });
  document.addEventListener('click', function (e) {
    if (H.contains(e.target) || (DRAWER && DRAWER.contains(e.target))) return;
    if (!RES.hidden) { closeRes(); if (desk.matches) showScrim(false); }
  });

  /* ---------- slim header after scrolling ---------- */
  var SENT = $('ph-sent'), stuck = false;
  function stick(on) {
    if (on === stuck) return;
    if (on) { WRAP.style.height = WRAP.offsetHeight + 'px'; H.style.width = (document.documentElement.clientWidth) + 'px'; H.classList.add('is-stuck'); }
    else { H.classList.remove('is-stuck', 'is-navopen'); var d = $('ph-depts'); if (d) d.setAttribute('aria-expanded', 'false'); WRAP.style.height = ''; H.style.width = ''; }
    stuck = on; setB();
  }
  if (SENT && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var r = en[0];
      if (!POP.hidden && !desk.matches) return;
      stick(!r.isIntersecting && r.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(SENT);
    window.addEventListener('resize', function () { if (stuck) { H.style.width = document.documentElement.clientWidth + 'px'; } setB(); });
  }

  /* ---------- keep in step with the planner, other tabs ---------- */
  document.addEventListener('ppc:pond', function (e) { if (e.detail && e.detail.from === 'header') return; load(); renderPond(); });
  window.addEventListener('storage', function (e) { if (e.key === 'ppc-pond') { load(); renderPond(); } });

  load(); renderPond();
})();
